/* Publish by EComposer at 2026-10-31 08:42:12*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-ylz3vgxgwop"]=  window.__ectimmers["ecom-ylz3vgxgwop"] || {};
if(!this.settings||!this.$el||this.isLive)return;const t=this.$el;let e=t.querySelectorAll('script:not([type="application/json"])');e.length>0&&e.forEach(function(i){let n=document.createElement("script");n.type="text/javascript",n.innerText=i.innerText,i.src&&(n.src=i.src),t.appendChild(n),i.remove()})

                    });
                    
                        document.querySelectorAll('.ecom-ylz3vgxgwop').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ylz3vgxgwop', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-u38soz9dx2l"]=  window.__ectimmers["ecom-u38soz9dx2l"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),n=t.querySelector(".text-content.ecom-html");!n||(e&&e.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-u38soz9dx2l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u38soz9dx2l', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wgp3v50k3a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wgp3v50k3a', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xeox2fo3ygk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xeox2fo3ygk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-93qne9j6s3c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-93qne9j6s3c', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-bz3e9vilvci"]=  window.__ectimmers["ecom-bz3e9vilvci"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-bz3e9vilvci"]["jmlg978vm"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let n=this.$el;if(!n)return;function o(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function s(){let r=n.querySelector(".ecom-element.ecom-base-image"),a=n.closest(".core__row--columns");r&&(o(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){s()})

                    });
                    
                        document.querySelectorAll('.ecom-bz3e9vilvci').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bz3e9vilvci', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}